export default "__VITE_ASSET__Ck3DN1id__"